import styled from "styled-components";
import { FormElement, Input, ValidationState } from "../shared-style";

export const StyledFormElement = styled(FormElement)`
    .NoWrap {
        word-break: break-all;
    }
    .Code {
        font-family: Courier, serif;
        font-size: 15px;
    }
`;

export const StyledInputTextArea = styled.textarea`
    ${Input}
    ${ValidationState}
    height: 180px;
`;
